"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUpdateCart = void 0;
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackUpdateCart(cart) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'updateCart',
        cart,
    });
}
exports.trackUpdateCart = trackUpdateCart;
//# sourceMappingURL=trackUpdateCart.js.map